export default "__VITE_ASSET__BgVkZnbz__"